import React from 'react';
import type { Task } from '../../../packages/api-client/pm-api';
import { RecurrenceConfig, ruleLabel } from '../../../components/RecurrenceConfig';
import type { RecurrenceRule } from '../../../packages/api-client/recurrence-api';
import { Repeat } from 'lucide-react';

const hours = (h?: number) => (h == null ? 'Not set' : `${h} h`);

/** readOnly (no tasks:update) shows the stored hours as text. */
export function EstimateFields({ task, save, readOnly = false }: {
    task: Task;
    save: (patch: Partial<Task>) => Promise<void>;
    readOnly?: boolean;
}) {
    if (readOnly) return (
        <div className="task-props task-props--two">
            <div className="task-prop"><span className="task-prop-label">Estimated</span><span className="task-prop-value">{hours(task.estimated_hours)}</span></div>
            <div className="task-prop"><span className="task-prop-label">Actual</span><span className="task-prop-value">{hours(task.actual_hours)}</span></div>
        </div>
    );
    return (
        <div className="task-props task-props--two">
            <label className="task-prop">
                <span className="task-prop-label">Estimated hours</span>
                <input type="number" className="form-input task-prop-control" min={0} step={0.5}
                    value={task.estimated_hours ?? ''}
                    onChange={e => { const v = parseFloat(e.target.value); save({ estimated_hours: isNaN(v) ? undefined : v }); }} />
            </label>
            <label className="task-prop">
                <span className="task-prop-label">Actual hours</span>
                <input type="number" className="form-input task-prop-control" min={0} step={0.5}
                    value={task.actual_hours ?? ''}
                    onChange={e => { const v = parseFloat(e.target.value); save({ actual_hours: isNaN(v) ? undefined : v }); }} />
            </label>
        </div>
    );
}

/** readOnly (no tasks:update — the recurrence routes' gate) shows the rule as text. */
export function RecurrenceField({ task, setTask, readOnly = false }: {
    task: Task;
    setTask: React.Dispatch<React.SetStateAction<Task | null>>;
    readOnly?: boolean;
}) {
    const rule = (task as Task & { recurrence_rule?: RecurrenceRule }).recurrence_rule ?? null;
    return (
        <div className="task-recurrence">
            <h3 className="task-subheading"><Repeat size={14} aria-hidden /> Recurrence</h3>
            {readOnly
                ? <p className="task-muted">{rule ? ruleLabel(rule) : 'Does not repeat.'}</p>
                : <RecurrenceConfig
                    taskId={task.id}
                    currentRule={rule}
                    onChange={(r) => setTask(t => t ? { ...t, recurrence_rule: r ?? undefined } as typeof t : t)}
                />}
        </div>
    );
}
